export const DEFAULT_LANDING_TITLE = "Welcome";

export enum ROUTE_PRODUCT_PREFIXES {
  "model" = "model",
  "studio" = "studio",
}
